/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApiResultDto } from '../models/api-result-dto';
import { NewPersonProjectRole } from '../models/new-person-project-role';
import { PersonProjectRole } from '../models/person-project-role';
import { PersonProjectRoleBulkProcesses } from '../models/person-project-role-bulk-processes';
import { PersonProjectRolePartial } from '../models/person-project-role-partial';
import { PersonProjectRoleWithRelations } from '../models/person-project-role-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class PersonProjectRoleControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation personProjectRoleControllerBulkCreate
   */
  static readonly PersonProjectRoleControllerBulkCreatePath = '/person-project-roles/bulk-create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreate$Response(params?: {
    body?: PersonProjectRoleBulkProcesses
  }): Observable<StrictHttpResponse<ApiResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerBulkCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `bulkCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreate(params?: {
    body?: PersonProjectRoleBulkProcesses
  }): Observable<ApiResultDto> {

    return this.bulkCreate$Response(params).pipe(
      map((r: StrictHttpResponse<ApiResultDto>) => r.body as ApiResultDto)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerBulkDelete
   */
  static readonly PersonProjectRoleControllerBulkDeletePath = '/person-project-roles/bulk-delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkDelete$Response(params?: {
    body?: PersonProjectRoleBulkProcesses
  }): Observable<StrictHttpResponse<ApiResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerBulkDeletePath, 'delete');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `bulkDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkDelete(params?: {
    body?: PersonProjectRoleBulkProcesses
  }): Observable<ApiResultDto> {

    return this.bulkDelete$Response(params).pipe(
      map((r: StrictHttpResponse<ApiResultDto>) => r.body as ApiResultDto)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerCount
   */
  static readonly PersonProjectRoleControllerCountPath = '/person-project-roles/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerFindById
   */
  static readonly PersonProjectRoleControllerFindByIdPath = '/person-project-roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<PersonProjectRole>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonProjectRole>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<PersonProjectRole> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<PersonProjectRole>) => r.body as PersonProjectRole)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerDeleteById
   */
  static readonly PersonProjectRoleControllerDeleteByIdPath = '/person-project-roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<void> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerUpdateById
   */
  static readonly PersonProjectRoleControllerUpdateByIdPath = '/person-project-roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: PersonProjectRolePartial
  }): Observable<StrictHttpResponse<PersonProjectRole>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonProjectRole>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: PersonProjectRolePartial
  }): Observable<PersonProjectRole> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<PersonProjectRole>) => r.body as PersonProjectRole)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerFind
   */
  static readonly PersonProjectRoleControllerFindPath = '/person-project-roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<PersonProjectRoleWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonProjectRoleWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<PersonProjectRoleWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonProjectRoleWithRelations>>) => r.body as Array<PersonProjectRoleWithRelations>)
    );
  }

  /**
   * Path part for operation personProjectRoleControllerCreate
   */
  static readonly PersonProjectRoleControllerCreatePath = '/person-project-roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewPersonProjectRole
  }): Observable<StrictHttpResponse<PersonProjectRole>> {

    const rb = new RequestBuilder(this.rootUrl, PersonProjectRoleControllerService.PersonProjectRoleControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonProjectRole>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewPersonProjectRole
  }): Observable<PersonProjectRole> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<PersonProjectRole>) => r.body as PersonProjectRole)
    );
  }

}
